// extracted by mini-css-extract-plugin
module.exports = {"image":"malt-image-Image-image-3dd7db13"};